import api from './api';
import type { PageView, UserView } from '../types';

export const pageViewService = {
  trackPageView: async (pagePath: string): Promise<{ success: boolean }> => {
    return api.post('page-view', { json: { pagePath } }).json<{ success: boolean }>();
  },

  getPageStats: async (): Promise<PageView[]> => {
    return api.get('admin/page-stats').json<PageView[]>();
  },

  getPageViewers: async (pagePath: string): Promise<UserView[]> => {
    return api
      .get(`admin/page-stats/${encodeURIComponent(pagePath)}/viewers`)
      .json<UserView[]>();
  },
};
